export var RETURN_AUTO_ORDERS_FILTER_ID = 1;
export var RETURN_MIGRATED_ORDERS_FILTER_ID = 2;
export var UPDATE_ORDER_TYPE_FILTER = 'UPDATE_ORDER_TYPE_FILTER';
export var updateOrderTypeFilter = function updateOrderTypeFilter(data) {
  return {
    type: UPDATE_ORDER_TYPE_FILTER,
    payload: data
  };
};
export var UPDATE_ORDER_KIND_FILTER = 'UPDATE_ORDER_KIND_FILTER';
export var updateOrderKindFilter = function updateOrderKindFilter(data) {
  return {
    type: UPDATE_ORDER_KIND_FILTER,
    payload: data
  };
};
export var UPDATE_ORDER_STATUS_FILTER = 'UPDATE_ORDER_STATUS_FILTER';
export var updateOrderStatusFilter = function updateOrderStatusFilter(data) {
  return {
    type: UPDATE_ORDER_STATUS_FILTER,
    payload: data
  };
};
export var UPDATE_ORDER_HISTORY_PAGE_NUMBER = 'UPDATE_ORDER_HISTORY_PAGE_NUMBER';
export var updatePageNumber = function updatePageNumber(data) {
  return {
    type: UPDATE_ORDER_HISTORY_PAGE_NUMBER,
    payload: data
  };
};
export var UPDATE_ORDER_PAGE_SIZE_PREFERENCE = 'UPDATE_ORDER_PAGE_SIZE_PREFERENCE';
export var updatePageSizePreference = function updatePageSizePreference(pageSize) {
  return {
    type: UPDATE_ORDER_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};
export var UPDATE_ORDER_HISTORY_DATE_RANGE = 'UPDATE_ORDER_HISTORY_DATE_RANGE';
export var updateDateRange = function updateDateRange(data) {
  return {
    type: UPDATE_ORDER_HISTORY_DATE_RANGE,
    payload: data
  };
};
export var REMOVE_ORDER_HISTORY_FILTER = 'REMOVE_ORDER_HISTORY_FILTER';
export var removeOrderHistoryFilter = function removeOrderHistoryFilter() {
  return {
    type: REMOVE_ORDER_HISTORY_FILTER
  };
};